/**
 * @file
 * Fulbright mobile menu.
 */

(function($) {
  var menu = $("#main-menu-mobile");

  if (menu.length) {
    // Initialise slimMenu with options.
    menu.slimmenu({
      animSpeed: "fast",
      collapserTitle: "",
      easingEffect: null,
      indentChildren: true,
      resizeWidth: "1269"
    });

    // Toggle menu button class for theming purposes.
    $(".collapse-button").on("click", function(event) {
      $(this).toggleClass("open");
    });
  }
})(jQuery);
